import styled from 'styled-components'
import Link from 'components/Link'

const LinkUnstyled = styled(Link)`
  color: inherit;
  text-decoration: inherit;

  &:hover,
  &:active,
  &:link {
    color: inherit;
    text-decoration: inherit;
  }
`

export default LinkUnstyled
